class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.bindEvents = this.bindEvents.bind(this);
    this.toggleBackToTop = this.toggleBackToTop.bind(this);
  }
  connectedCallback() {
    this.showBackToTopFromTop = window.innerHeight + 400;
    this.hideBackToTopFrom = document.body.offsetHeight + window.innerHeight;
    this.backToTopEl = this.querySelector(".js-back-to-top");
    this.button = this.querySelector("button");
    this.bindEvents();
  }
  bindEvents() {
    if (this.backToTopEl) {
      this.toggleBackToTop(window.innerHeight + window.scrollY);
      window.addEventListener("scroll", () => {
        this.toggleBackToTop(window.innerHeight + window.scrollY);
      });
    }
    if (this.button) {
      this.button.addEventListener("click", this.scrollToTop);
    }
  }
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  toggleBackToTop(scrollPosition) {
    if (scrollPosition > this.showBackToTopFromTop && scrollPosition < this.hideBackToTopFrom) {
      this.backToTopEl.classList.add("back-to-top--visible");
    } else {
      this.backToTopEl.classList.remove("back-to-top--visible");
    }
  }
}
customElements.define("w3-back-to-top", BackToTop);
